import {
  baseUniDriverFactory,
  findByHook,
} from '../utils/test-utils/unidriver';
import type { UniDriver } from '@wix/wix-ui-test-utils/unidriver';
import { DATA_HOOKS } from './FullScreenModalLayout.constants';

export const fullScreenModalLayoutDriverFactory = (base: UniDriver) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Gets the header text
     * @returns {Promise<string>}
     */
    getHeaderText: () =>
      findByHook(base, DATA_HOOKS.fullScreenModalLayoutHeader).text(),

    /**
     * Gets the content text
     * @returns {Promise<string>}
     */
    getContentText: () =>
      findByHook(base, DATA_HOOKS.fullScreenModalLayoutContent).text(),

    /**
     * Gets the footer text
     * @returns {Promise<string>}
     */
    getFooterText: () =>
      findByHook(base, DATA_HOOKS.fullScreenModalLayoutFooter).text(),
  };
};

export type FullScreenModalLayoutUniDriver = ReturnType<
  typeof fullScreenModalLayoutDriverFactory
>;
